import { locale, Model } from '@glu/core';

export default Model.extend({
  defaults: {
    name: '',
    default: false
  },

  validators: {
    name: {
      description: locale.get('savedViewName'),
      exists: true,
      maxLength: 50
    }
  }
});
